var iFrameDom = {
  replace: function($targetElement, content, options) {
    iFrameDom.include($targetElement, content, options, "replace");
  },
  append : function($targetElement, content, options) {
    iFrameDom.include($targetElement, content, options, "append");
  },
  prepend: function($targetElement, content, options) {
    iFrameDom.include($targetElement, content, options, "prepend");
  },
  include: function($targetElement, content, options, mode) {
    var $iframe                   = null;
    var $viewOnWhiteBackgroundDiv = "";
    var $beforeIframe             = "";
    if (options.viewOriginalOption === true) {
      $viewOnWhiteBackgroundDiv = $("<a href='javascript:void(0)'>View original</a>");
      $beforeIframe             = $("<div class='alert alert-warning'></div>");
      $beforeIframe.html("The background and text colors have been modified to fit your theme. ");
      $beforeIframe.append($viewOnWhiteBackgroundDiv);
      $beforeIframe.append("<br>");
    }
    else {
      $beforeIframe = "";
    }
    $iframe = $("<iframe style='width: 100%; border: none;'></iframe>");
    switch (mode) {
      case "append":
        $targetElement.append($beforeIframe);
        $targetElement.append($iframe);
        break;
      default:
      case "replace":
        $targetElement.html($beforeIframe);
        $targetElement.append($iframe);
        break;
      case "prepend":
        $targetElement.prepend($iframe);
        $targetElement.prepend($beforeIframe);
        break;
    }

    $divToChange = $iframe.contents().find("body");
    $iframe.on("load", function(e) {
      iFrameDom.iFrameOnLoadMethod($iframe, content, options);
    });
    if (options.viewOriginalOption === true) {
      $viewOnWhiteBackgroundDiv.click(function() {
        $(this).parent().remove();
        $iframe.css("background", "white");
        var $divToChange   = $iframe.contents().find("body");
        var originalStyles = $divToChange.data("originalStyles");
        var styleName;
        for (styleName in originalStyles) {
          if (originalStyles.hasOwnProperty(styleName)) {
            $divToChange.css(styleName, originalStyles[styleName]);
          }
        }

      });
    }
    // adding a "src" breaks ie + edge... about:blank is apparently a "different domain". :P
    if (!(document.documentMode || /Edge/.test(navigator.userAgent))) {
      // must give a 'src' or chrome doesn't fire the 'onload' event....
      $iframe.attr("src", "about:blank");
    }
  },
  /*
  * iFrameOnLoadMethod
  * */
  iFrameOnLoadMethod: function($iframe, content, options) {
    var iFrameDocument = ($iframe[0].contentWindow || $iframe[0].contentDocument);
    if (iFrameDocument.location.href === "about:blank") {
      var $divToChange = $iframe.contents().find("body");
      $divToChange.html(content);
    }
    var styleName;
    var originalStyles = {};
    if (typeof options !== "undefined") {
      if (typeof options.style === "object" && options.style !== null) {
        for (styleName in options.style) {
          if (options.style.hasOwnProperty(styleName)) {
            originalStyles[styleName] = $divToChange.css(styleName);
            $divToChange.css(styleName, options.style[styleName]);
          }
        }
      }
    }
    if (typeof $divToChange !==
        "undefined" &&
        (typeof $divToChange.data("originalStyles") === "undefined" || $divToChange.data("originalStyles").length < 1)) {
      $divToChange.data("originalStyles", originalStyles);
    }

    if (typeof iFrameResize === "function") {
      if (typeof options !== "undefined" && typeof options.resizeOptions !== "undefined") {
        iFrameResize($iframe, options.resizeOptions);
      }
      else {
        iFrameResize($iframe);
      }

    }
    else {
      console.log("iFrameResize function not found. Install 'skeets.iframe-resize' through npm.");
    }
  }
};

